import { Stack, TextInput } from "@mantine/core"
import { useDebouncedValue } from "@mantine/hooks"
import { IconSearch } from "@tabler/icons-react"
import { PaginationState } from "@tanstack/react-table"
import {
  DataFetchWrapper,
  ExportButton,
  ExportType,
  SectionHeader,
} from "@tfg/ui"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { SupplierProductionSites } from "~/pages/Brand/Suppliers/List/SupplierProductionSites/SupplierProductionSites.tsx"
import { useListSuppliersProductionSitesQuery } from "~/pages/Brand/Suppliers/List/supplierHooks.ts"
import { useDownloadSuppliersProdSitesCSVMutation } from "~/pages/Brand/Suppliers/hooks.ts"

export const PAGE_SIZE = 20

export const SupplierProductionSitesWrapper = () => {
  const { t } = useTranslation(["suppliers", "common"])
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: PAGE_SIZE,
  })
  const [searchProductionSite, setSearchProductionSite] = useState<string>("")
  const [debouncedProductionSite] = useDebouncedValue<string>(
    searchProductionSite,
    600
  )
  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      pageIndex: 0,
    }))
  }, [debouncedProductionSite])
  const productionSitesQuery = useListSuppliersProductionSitesQuery({
    fetchDataOptions: pagination,
    searchProductionSite: debouncedProductionSite,
  })

  const { mutate: downloadMutation, isLoading: isSuppliersCSVDownloading } =
    useDownloadSuppliersProdSitesCSVMutation({
      searchProductionSite: debouncedProductionSite,
    })
  return (
    <>
      <SectionHeader
        title={t("productionSites.title")}
        mainCta={
          <ExportButton
            label={t("common:actionButtons.export")}
            exportOptions={[
              {
                type: ExportType.CSV,
                label: t("common:actionButtons.exportAsCsv"),
                exportFunction: downloadMutation,
                isLoading: isSuppliersCSVDownloading,
              },
            ]}
          />
        }
      />
      <DataFetchWrapper query={productionSitesQuery}>
        {({ data }) => (
          <Stack gap="xs">
            <TextInput
              label={t("list.searchLabel")}
              value={searchProductionSite}
              autoFocus
              onChange={(e) => setSearchProductionSite(e.target.value)}
              w={180}
              size="xs"
              leftSection={<IconSearch size={16} />}
              placeholder={t("list.searchPlaceholder")}
            />
            <SupplierProductionSites
              productionSitesData={data}
              setPagination={setPagination}
              pagination={pagination}
              searchProductionSites={searchProductionSite}
              setSearchProductionSites={setSearchProductionSite}
            />
          </Stack>
        )}
      </DataFetchWrapper>
    </>
  )
}
